import { TenantContactType } from "generated-graphql/graphql";

/** Account-team roles from Salesforce, as staff read them. */
export const ROLE_LABELS: Record<TenantContactType, string> = {
  [TenantContactType.Csm]: "CSM",
  [TenantContactType.AccountManager]: "Account manager",
  [TenantContactType.DataManager]: "Data manager",
  [TenantContactType.WasteManager]: "Waste manager",
  [TenantContactType.CustomerPoc]: "Customer contact",
};
